import * as React from 'react';

import ModalBase, { ModalBasicProps } from '@/components/layouts/Modal/Base';

interface DigestModalProps extends ModalBasicProps {
  videoUrl: string;
}

const DigestModalContent: React.FC<DigestModalProps> = ({ videoUrl }) => {
  return (
    <video autoPlay controls width="100%">
      <source src={`${videoUrl}-01.mp4`} type="video/mp4" />
      <source src={`${videoUrl}-00.mp4`} type="video/mp4" />
    </video>
  );
};

const DigestModal: React.FC<DigestModalProps> = ({
  isOpen,
  handleClose,
  videoUrl,
}) => {
  return (
    <ModalBase
      isOpen={isOpen}
      handleClose={handleClose}
      desktopWidth="640px"
      mobileWidth="95%"
      backgroundColor=" "
      paddingSize="0px"
      radiusSize="0px"
      hideCloseButton={true}
    >
      <DigestModalContent
        isOpen={isOpen}
        handleClose={handleClose}
        videoUrl={videoUrl}
      />
    </ModalBase>
  );
};

export default DigestModal;
